import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  row: {
    display: 'grid',
    gridTemplateColumns: '400px 200px 72px',
    justifyContent: 'space-between',
    width: '100%',
    gap: 8,
    padding: '8px 32px',
    alignItems: 'center',
    '&.error': {
      background: '#FDECEC61',
      '& $title': {
        color: theme.palette.error.main,
      },
    },
  },
  end: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  icon: {
    color: theme.palette.primary.dark,
  },
  title: {},
  emptyButton: {
    height: '40px',
  },
}))
